var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModifierIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13C15.6904 13 16.25 12.5523 16.25 12C16.25 11.4477 15.6904 11 15 11C14.3096 11 13.75 11.4477 13.75 12C13.75 12.5523 14.3096 13 15 13Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6C15.6904 6 16.25 5.55228 16.25 5C16.25 4.44772 15.6904 4 15 4C14.3096 4 13.75 4.44772 13.75 5C13.75 5.55228 14.3096 6 15 6Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20C15.6904 20 16.25 19.5523 16.25 19C16.25 18.4477 15.6904 18 15 18C14.3096 18 13.75 18.4477 13.75 19C13.75 19.5523 14.3096 20 15 20Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifierIcon);
export default __webpack_public_path__ + "static/media/modifierIcon.cb654dc94c95a3d0cb9b4d63503e618f.svg";
export { ForwardRef as ReactComponent };